import { render, staticRenderFns } from "./PlayBreadcrumbItem.vue?vue&type=template&id=6e4c00f2&scoped=true"
import script from "./PlayBreadcrumbItem.vue?vue&type=script&lang=js"
export * from "./PlayBreadcrumbItem.vue?vue&type=script&lang=js"
import style0 from "./PlayBreadcrumbItem.vue?vue&type=style&index=0&id=6e4c00f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4c00f2",
  null
  
)

export default component.exports